import React, { useEffect, useState } from 'react';

function SupportButton() {
  const [isVisible, setIsVisible] = useState(true)
  const redirectSupport = () => {
    window.open('https://ebullion.in/contact-us', '_blank');
  };
  useEffect(() => {
    let timeout;

    const handleScroll = () => {
      setIsVisible(false);

      clearTimeout(timeout);
      timeout = setTimeout(() => {
        setIsVisible(true);
      }, 500); // Adjust the timeout duration as needed
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      clearTimeout(timeout);
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return (
    <div className={`floating-button  ${isVisible ? 'visible' : 'hidden'}`}>
      <button className='wiggle' onClick={() => redirectSupport()}>
        Help?
      </button>
    </div>
  );
}

export default SupportButton;
